import { SxProps } from '@mui/material';

export const LogoStyles: SxProps = {
  cursor: 'pointer',
  height: '30px',
};
